import InputTypesEnum from '../../../Enums/InputTypesEnum';
import SurveyTransferMappingService from '../../../Services/SurveyTransferMappingService';
import SurveyTransferQuestionMappingItem from '../../../Domain/SurveyTransferQuestionMappingItem';

// SourceType values must match the backend (SurveyTransferSourceTypeConstants / the DB CHECK).
const SOURCE_TYPE_QUESTION = 'Question';
const SOURCE_TYPE_JOB_DATA = 'JobData';

const SOURCE_TYPE_OPTIONS = [
  { value: SOURCE_TYPE_QUESTION, label: "Question (a source question's answer)" },
  { value: SOURCE_TYPE_JOB_DATA, label: 'Job data (a field of the job)' },
];

// Hardcoded job-field keys (must match the backend SurveyTransferSourceKeyConstants).
// The leading empty "(None)" entry is just a placeholder so the dropdown doesn't look like the
// first real key is already chosen; it fails the validityChecker, so it can't be saved.
const SOURCE_KEY_OPTIONS = [
  { value: '', label: '(None)' },
  { value: 'Job.JobDate', label: 'Job.JobDate' },
  { value: 'Job.StartDateTime', label: 'Job.StartDateTime' },
  { value: 'Job.EndDateTime', label: 'Job.EndDateTime' },
];

// GeneralEditPanelBase (Figma) description for editing a single question rule. Pick the source
// kind (SourceType): "Question" shows the searchable source-question dropdown (empty = NULL);
// "JobData" shows a dropdown of hardcoded job-field keys. The selectable source questions are
// attached to the edited item by the page as `SourceQuestionOptions` ({ value, text, secondaryId }).
export default class SurveyTransferQuestionMappingPanelDescription {
  static itemType = SurveyTransferQuestionMappingItem;
  static headerForEditPanel = 'Edit Question Mapping';
  static headerForCreatePanel = 'Edit Question Mapping';
  static labelForSubmitButton = 'Save';
  static nameOfTheIdField = 'SurveyTransferQuestionMappingId';
  static icon = 'fa-solid fa-edit';
  static messageOnSuccess = 'The question rule has been saved.';

  static clickOnSubmitFunction = (editedItem) =>
    SurveyTransferMappingService.UpdateQuestionMappingRule(
      editedItem.SurveyTransferQuestionMappingId,
      editedItem.SourceTpQuestionId,
      editedItem.SourceType,
      editedItem.SourceKey
    );

  static fieldsInEditPanel = [
    {
      fieldName: 'TargetTpQuestionText',
      label: 'Target Question',
      className: 'col-12',
      type: InputTypesEnum.TextBoxReadOnly,
      numberOfRows: 4,
    },
    {
      fieldName: 'SourceType',
      label: 'Source Type',
      className: 'col-12',
      type: InputTypesEnum.Select,
      options: SOURCE_TYPE_OPTIONS,
    },
    {
      fieldName: 'SourceTpQuestionId',
      label: 'Source Question',
      className: 'col-12',
      type: InputTypesEnum.SourceQuestionSelect,
      options: (editedItem) => editedItem.SourceQuestionOptions,
      placeholder: 'Search and select a source question...',
      numberOfRows: 4,
      // Only relevant when the source is another question.
      hide: (editedItem) => editedItem.SourceType === SOURCE_TYPE_JOB_DATA,
    },
    {
      fieldName: 'SourceKey',
      label: 'Source Job Field',
      className: 'col-12',
      type: InputTypesEnum.Select,
      options: SOURCE_KEY_OPTIONS,
      // Only relevant (and required) when the source is job data.
      hide: (editedItem) => editedItem.SourceType !== SOURCE_TYPE_JOB_DATA,
      validityChecker: (value, editedItem) =>
        editedItem.SourceType === SOURCE_TYPE_JOB_DATA && !value ? 'Please select a source job field.' : '',
    },
  ];
}
